import React from "react";
import { Link } from "react-router-dom";
import { LogoMark } from "./Logo";
import { useLang } from "../context/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="footer" className="bg-ink border-t border-amber/15 text-cream/80">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-12 gap-10 md:gap-8">
          <div className="col-span-2 md:col-span-5">
            <div className="flex items-center gap-2.5 mb-5">
              <LogoMark size={32} />
              <span className="font-display text-2xl font-extrabold text-cream tracking-tight" style={{ letterSpacing: "-0.04em" }}>
                Pendli
              </span>
            </div>
            <p className="text-sm md:text-base text-cream/60 max-w-sm leading-relaxed">
              {t.footer.tagline}
            </p>
            <p className="text-xs text-amber/80 mt-6 font-bold tracking-widest uppercase">
              {t.footer.built}
            </p>
          </div>

          <div className="md:col-span-2 md:col-start-7">
            <h4 className="text-xs font-bold tracking-widest uppercase text-amber mb-4">
              {t.footer.sections.product}
            </h4>
            <ul className="space-y-3 text-sm">
              <li><Link className="amber-link" to="/pendler" data-testid="footer-link-pendler">{t.footer.links.pendler}</Link></li>
              <li><Link className="amber-link" to="/huseier" data-testid="footer-link-huseier">{t.footer.links.huseier}</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-bold tracking-widest uppercase text-amber mb-4">
              {t.footer.sections.company}
            </h4>
            <ul className="space-y-3 text-sm">
              <li><Link className="amber-link" to="/om-oss" data-testid="footer-link-om">{t.footer.links.om}</Link></li>
              <li><Link className="amber-link" to="/kontakt" data-testid="footer-link-kontakt">{t.footer.links.kontakt}</Link></li>
              <li><a className="amber-link" href="mailto:hello@pendli.no" data-testid="footer-link-email">hello@pendli.no</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-bold tracking-widest uppercase text-amber mb-4">
              {t.footer.sections.legal}
            </h4>
            <ul className="space-y-3 text-sm">
              <li><Link className="amber-link" to="/personvern" data-testid="footer-link-personvern">{t.footer.links.privacy}</Link></li>
              <li><Link className="amber-link" to="/vilkar" data-testid="footer-link-vilkar">{t.footer.links.terms}</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-amber/10">
          <p className="text-xs text-cream/40">
            © 2026 Pendli · pendli.no · {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
}
